// i18n.js
import { createI18n } from 'vue-i18n';

// Helper to manage language in localStorage
export const languageManager = {
  getLanguage() {
    try {
      return localStorage.getItem('user-language') || process.env.VUE_APP_I18N_LOCALE || 'en';
    } catch (e) {
      console.error('Error accessing localStorage:', e);
      return process.env.VUE_APP_I18N_LOCALE || 'en';
    }
  },
  setLanguage(lang) {
    try {
      localStorage.setItem('user-language', lang);
      return lang;
    } catch (e) {
      console.error('Error writing to localStorage:', e);
      return lang;
    }
  }
};

// Define available locales
const locales = ['en', 'de', 'lv', 'ru'];

async function loadLocaleMessages() {
  const messages = {};
  
  // Load each locale file dynamically
  for (const locale of locales) {
    try {
      const module = await import(`./locales/${locale}.json`);
      messages[locale] = module.default;
    } catch (error) {
      console.error(`Failed to load locale ${locale}:`, error);
    }
  }
  
  return messages;
}

// Create i18n instance with empty messages initially
const i18n = createI18n({
  legacy: false, // You're using Composition API
  globalInjection: true, // Enables $t in templates
  locale: languageManager.getLanguage(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {} // Start with empty messages
});

// Load messages and update i18n instance
loadLocaleMessages().then(messages => {
  i18n.global.setLocaleMessage('en', messages.en);
  i18n.global.setLocaleMessage('de', messages.de);
  i18n.global.setLocaleMessage('lv', messages.lv);
  i18n.global.setLocaleMessage('ru', messages.ru);
});

// Function to change language globally
export function setI18nLanguage(lang) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = lang;
  } else {
    i18n.global.locale.value = lang;
  }
  languageManager.setLanguage(lang);
  document.querySelector('html').setAttribute('lang', lang);
  console.log(`Language set to: ${lang}`);
  return lang;
}

export { loadLocaleMessages };

export default i18n;